import React, { Component } from "react";
import { matchPath } from "react-router";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Creators as ReasonsActions } from "store/ducks/reasons";

import { Validate } from "common";
import { Page, Breadcrumbs } from "components";
import { Form } from "pages/Reasons/components";

class Edit extends Component {
  state = {
    data: {
      title: "",
      description: "",
      alias: "",
    },
    errors: {},
    loading: true,
    breadcrumbs: [
      { name: "Home", to: "/" },
      { name: "Lista de Razões", to: "/reasons/list" },
      { name: "Editar", to: "" },
    ],
  };

  componentDidMount() {
    const { getReasonRequest } = this.props;
    getReasonRequest(this.handleGetID());
  }

  componentDidUpdate(oldProps) {
    const { data } = this.state;
    const { reason } = this.props;

    if (oldProps.reason.loading && !reason.loading) {
      const values = {
        ...data,
        ...reason.data,
        id: reason.data.id,
        description:
          reason.data.description !== null ? reason.data.description : "",
        alias: reason.data.alias !== null ? reason.data.alias : "",
      };

      this.setState({
        data: values,
        loading: false,
      });
    }
  }

  handleGetID = () => {
    const match = matchPath(this.props.location.pathname, {
      path: "/reasons/:id/edit",
    });
    return match.params.id;
  };

  handleChange = (data) => {
    const { errors } = this.state;

    this.setState({ data });

    Object.keys(errors).length && this.handleValidate();
  };

  handleValidate = () => {
    const { data } = this.state;

    const rules = {
      title: {
        required: true,
      },

      description: {
        required: true,
      },

      alias: {
        required: true,
      },
    };

    const validate = Validate(data, rules);
    this.setState({ errors: validate.errors });

    return validate.valid;
  };

  handleSave = () => {
    if (!this.handleValidate()) return null;

    const { data } = this.state;
    const { updateReasonRequest } = this.props;

    updateReasonRequest(this.handleGetID(), {
      title: data.title,
      description: data.description,
      alias: data.alias,
    });
  };

  render() {
    const { data, errors, breadcrumbs, loading } = this.state;
    const { update } = this.props;

    return (
      <Page>
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <Form
          data={data}
          loading={loading}
          errors={errors}
          edit
          saving={update.loading}
          onChange={this.handleChange}
          onSave={this.handleSave}
        />
      </Page>
    );
  }
}

const mapState = (state) => ({
  reason: state.reasons.detail,
  update: state.reasons.update,
});

const mapActions = (dispatch) => bindActionCreators(ReasonsActions, dispatch);

export default connect(mapState, mapActions)(Edit);
